import React, { useRef }    from 'react';
import PropTypes            from 'prop-types';

import MainBlock            from './Blocks/MainBlock';
import ServicesBlock        from './Blocks/ServicesBlock';
import OpportunitiesBlock   from './Blocks/OpportunitiesBlock'
import ResultsBlock         from './Blocks/ResultsBlock';
import AvailabilityBlock    from './Blocks/AvailabilityBlock';
import RevolutionaryBlock   from './Blocks/RevolutionaryBlock';
import SubscribeBlock       from './Blocks/SubscribeBlock';
import StepsBlock           from './Blocks/StepsBlock';
import Header               from '../../components/Header';
import Footer               from '../../components/Footer';

// import useMessage      from './useHeader';


import styles           from './HomePage.styl';

function HomePage() {
    // const { className, children, ...rest } = props;

    // const {} = useMessage();
    const resultsRef = useRef();
    const stepsRef = useRef();
    const servicesRef = useRef();
    const opportunitiesRef = useRef();
    const revolutionaryRef = useRef();
    const availabilityRef = useRef();

    const refs = {
        resultsRef,
        stepsRef,
        servicesRef,
        opportunitiesRef,
        revolutionaryRef,
        availabilityRef
    };

    return  (
        <div className={styles.HomePage}>
            <Header refs = {refs} />
            <MainBlock />
            <ServicesBlock ref = {servicesRef} />
            <OpportunitiesBlock ref = {opportunitiesRef} />
            <RevolutionaryBlock ref = {revolutionaryRef} />
            <ResultsBlock ref = {resultsRef} />
            <StepsBlock ref = {stepsRef} />
            <AvailabilityBlock ref = {availabilityRef} />
            <SubscribeBlock />
            <Footer refs = {refs} />
        </div>
    );
}

HomePage.propTypes = {
    className : PropTypes.string
};

HomePage.defaultProps = {
    className : ''
};

export default HomePage;
